import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { Router } from "@angular/router";
import { SessionStorageService } from "angular-web-storage";
// import { NgxViacepModule } from "@brunoc/ngx-viacep";
import { HttpClient } from "@angular/common/http";

@Injectable({
	providedIn: "root"
})
export class InstituitionProvider {
	constructor(
		private http: HttpService,
		private router: Router, 
		private httpClient: HttpClient
		// private viacep: NgxViacepModule,
		// public session: SessionStorageService,
	) { }
	destroy(data: any): any {
		return new Promise((resolve, reject) => {
			this.http.post("api/institution/institution/deleteInstitution", true, data).then(res => {
			});
		});
	}
	createInstitution(data) {
		return new Promise((resolve, reject) => {
			this.http.post("api/institution/institution/createInstitution", true, data).then(res => {
				resolve(res);
			}).catch(err => {
				reject(err);
			});
		});
	}
	getAll(data): any {
		return new Promise((resolve, reject) => {
			this.http.post("api/institution/institution/getAll/", true, data).then(res => {
				resolve(res);
			});
		});
	}
	updateInstitution(data: any): any {
		return new Promise((resolve, reject) => {
			this.http.post("api/institution/institution/updateInstitution", true, data).then(res => {
				resolve(res);
			}).catch(err => {
				reject(err);
			});
		});
	}

	getById(data: any): any {
		console.log("ID PROCIDERS", data);
		return new Promise((resolve, reject) => {
			this.http.post("api/institution/institution/getById/", true, data).then(res => {

				console.log("RES", res);
				resolve(res);
			});
		});
	}

	getAllByServices(data: any = {}) {
		return new Promise((resolve, reject) => {
			this.http.post("api/institution/institution/getAllByServices", true, data).then(res => {
				resolve(res);
			}).catch(err => reject());
		});
	}
	institutionAvatar(data: any): any {

		return new Promise((resolve, reject) => {
			this.http.post("api/institution/institution/institutionAvatar/", true, data).then(res => {

				console.log("RES", res);
				resolve(res);
			});
		});
	}
	getCEP(cepValue) {
		return new Promise((resolve, reject) => {
			this.httpClient.get("https://viacep.com.br/ws/" + cepValue + "/json/")
			.subscribe(data => {
				resolve(data);
			});
		}).catch(err => console.log("Error trying to create schedule: ", err));

	}

}



